<template>
  <span class="cx_badge_user" :class="bgcolor">{{ this.initial}}</span>
</template>
<script lang="ts">
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';

@Component
export default class Badge extends Vue {

  @Prop() value: any;
  @Prop() list: string;

  public get initial():string {
    const name = this.$api.formatter.formatByList(this.value,this.list);
    return name.substring(0,1);
  }

  public get index():number{
    const items = this.$api.formatter.getOptions(this.list);
    return items.findIndex(obj => obj.value == this.value);
  }
  public get color(): string {

    switch (this.index % 6) { //lightとdarkは除外
      case 0: return 'navy';
      case 1: return 'blue';
      case 2: return 'aqua';
      case 3: return 'green';
      case 4: return 'yellow';
      case 5: return 'maroon';
      case 6: return 'fuchsia';
      default: return 'purple';
    }
  }
  public get bgcolor(): string{
    return 'bg-' + this.color + ' tx-' + this.color;
  }
}
</script>
<style lang="scss">
  .cx_badge_user{
    border-radius: 0.7rem;
    height: 1.4rem;
    width: 1.4rem;
    font-size:0.7rem;
    font-weight: 200;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    // color:steelblue;
  }
</style>
